/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FolderMenuOption_portfolio = {
    readonly serviceId: string | null;
    readonly firstItemImage: string | null;
    readonly isPublic: boolean | null;
    readonly items: {
        readonly totalResults: number | null;
    } | null;
    readonly name: string | null;
    readonly " $refType": "FolderMenuOption_portfolio";
};
export type FolderMenuOption_portfolio$data = FolderMenuOption_portfolio;
export type FolderMenuOption_portfolio$key = {
    readonly " $data"?: FolderMenuOption_portfolio$data;
    readonly " $fragmentRefs": FragmentRefs<"FolderMenuOption_portfolio">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FolderMenuOption_portfolio",
  "type": "PortfolioV2",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstItemImage",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "large"
        }
      ],
      "storageKey": "firstItemImage(size:\"large\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isPublic",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioItemsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'cc4175eb7831c05aa07c2b47eb1f0bf3';
export default node;
